<template>
  <div class="input-wrapper">
    <textarea :id="id" type="text" class="textarea" v-model="internValue" v-bind:maxlength="maxLength" v-bind:required="required"
              v-on:keyup="$emit('update:value',internValue)" :rows="rows"
              @input="onChange"
              spellcheck="false"/>
    <label class="label" v-bind:class="{'filled-input': value !== '' && value !== undefined && value !== null,'required': required && !value}">
      {{ placeHolder }}{{ required ? '*' : '' }} </label>
  </div>
</template>

<script>
import {isDefined} from "@/utils";
import {uuid} from "vue-uuid";

export default {
  name: "CustomInputTextArea",
  props: {
    value: {
      required: true
    },
    placeHolder: {
      required: false,
      type: String
    },
    required: {
      required: false,
      type: Boolean
    },
    maxLength: {
      required: false,
      type: Number,
      default: 255
    },
    rows: {
      required: false,
      type: Number,
      default: 1
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        this.internValue = newVal;
      }
    }
  },
  data() {
    return {
      internValue: undefined,
      id: undefined
    }
  },
  beforeUpdate() {
    this.$nextTick(function () {
      const tx = document.getElementById(this.id);
      if (tx) {
        tx.setAttribute('style', 'height:' + (tx.scrollHeight > 34 ? tx.scrollHeight : 34) + 'px;overflow-y:hidden;');
        tx.addEventListener("input", this.onInput, false);
      }
    });
  },
  mounted() {
    this.id = uuid.v1();
  },
  methods: {
    onInput() {
      const tx = document.getElementById(this.id);
      if (tx) {
        tx.style.height = 'auto';
        tx.style.height = (tx.scrollHeight > 34 ? tx.scrollHeight : 34) + 'px';
      }
    },
    onChange(inputEvent) {
      if (isDefined(inputEvent) && isDefined(inputEvent.data) && inputEvent.inputType === 'insertReplacementText') {
        this.internValue = inputEvent.data;
      }
      if (isDefined(inputEvent) && isDefined(inputEvent.data) && inputEvent.inputType === 'insertFromPaste'){
        this.internValue = this.internValue.trim();
      }
      this.$emit('update:value', this.internValue)
    },
  }
}
</script>

